module.exports = __webpack_public_path__ + "img/math__grass.16c04d2b.svg";